<template>
  <div id="contenedor-listado-mobiles">
    <v-card v-for="(municipio, index) in municipios" :key="index" class="mb-2">
      <v-card-title class="justify-space-between">
        <div class="d-inline-block text-truncate">
          {{ municipio.nombre }}
        </div>
        <div class="d-inline-block">
          <opciones :presupuesto="municipio"> </opciones>
        </div>
      </v-card-title>
      <v-card-text>
        {{ municipio.nombreCorto }}
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import MUNICIPIOS from '@/graphql/querys/administracion/catalogos/municipios/municipios.gql';
import Opciones from './Opciones.vue';

export default {
  name: 'ListadoPresupuestosMobiles',
  components: {
    Opciones,
  },
  data() {
    return {
    };
  },
  apollo: {
    municipios: {
      query: MUNICIPIOS,
    },
  },
};
</script>

<style lang="scss">

</style>
